<template>
  <AbsPopup id="ReportPopup" title="신고하기" @close="$emit('close')" @submit="submit" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <li v-if="option.param.title">
          <span>{{ titleName }} :</span>
          <span>{{ title }}</span>
        </li>
        <li v-if="option.param.post">
          <span>글 제목 :</span>
          <span>{{ subtitle }}</span>
        </li>
        <li>
          <span>작가명 :</span>
          <span>{{ nic }}</span>
        </li>
        <span class="line"/>
        <div class="selectType">
          <div>
            <span>사유선택</span>
          </div>
          <div>
            <li>
              여러사유에 해당되는 경우, 대표적인 사유 1개를 선택해 주세요
            </li>
            <li>
              운영원칙자세히 보기
            </li>
            <li v-for="(item, idx) in list" :key="idx">
              <label><input type="radio" name="type" :value="idx" @change="radioChange"/>
              {{ item }}</label>
            </li>
            <li>
              <label><input type="radio" name="type" :value="list.length" @change="radioChange"/>
              기타 ({{ commentEx.length }}/500)</label>
              <UInput v-if="parseInt(commentIdx) === list.length" type="textarea" :limitHeight="100" :auto="true" placeholder="신고 사유와 하실 말씀을 적어 주세요" v-model="commentEx" :limit="500" @focus="$store.commit('popup', false)" @focusout="$store.commit('popup', true)"/>
            </li>
          </div>
        </div>
        <span class="line"/>
        <div>
          <li>
            허위신고일 경우, 신고자의 서비스 활동이 제한될 수 있으니, 유의하시어 신중하게 신고해 주세요
          </li>
          <li>
            신고해주신 내용은 운영정책 및 서비스약관에 따라 처리됩니다.
          </li>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import TabBar from '@/components/layout/TabBar.vue'
// import {numberToComma, commaToNumber} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.$http.post('/api/user/myInfo').then((row) => {
      console.log(row)
      if (row.success) {
        this.info = row
        this.$emit('loading', false)
      } else {
      }
    })
  },
  data: () => {
    return {
      info: null,
      commentEx: '',
      comment: '',
      commentIdx: -1
    }
  },
  name: 'ReportPopup',
  watch: {
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '신고하기', state: 'require', click: this.submit}
      ]
    },
    type () {
      return this.option.param.type
    },
    titleName () {
      switch (this.type) {
        case 'work' :
          return '저작공간'
        case 'profile' :
          return ''
        default :
          return '책 제목'
      }
    },
    title () {
      return this.option.param.title
    },
    subtitle () {
      return this.option.param.subtitle
    },
    nic () {
      return this.option.param.nic
    },
    list () {
      switch (this.type) {
        case 'work' :
          return [
            '부적합한 홍보 제목',
            '음란성 또는 청소년에게 부적합한 제목',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        case 'profile' :
          return [
            '부적절한 프로필 사진',
            '부적절한 필명',
            '부적절한 홍보 소개 글',
            '음란성 또는 청소년에게 부적합한 소개 글',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        case 'book' :
          return [
            '부적절한 작가(책) 소개',
            '음란성 또는 청소년에게 부적합한 작가(책) 소개',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        case 'comment' :
          return [
            '부적합한 홍보 댓글',
            '음란성 또는 청소년에게 부적합한 내용',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
        default :
          return [
            '부적합한 홍보 게시글',
            '음란성 또는 청소년에게 부적합한 내용',
            '명예회손/사생활 침해 및 저작권 침해등'
          ]
      }
    }
  },
  methods: {
    radioChange (e) {
      console.log(e.target.value)
      this.commentIdx = e.target.value
      switch (e.target.value) {
        case this.list.length :
          break
        default :
          this.commentEx = ''
          break
      }
    },
    submit () {
      console.log('submit')
      console.log(this.list[this.commentIdx])
      var ob = {type: this.type, user: this.option.param.user, message: this.option.param.message}
      if (this.commentIdx === this.list.length) {
        ob.comment = '기타 / ' + this.commentEx
      } else {
        ob.comment = this.list[this.commentIdx]
      }
      switch (this.type) {
        case 'work' :
          ob.report = this.option.param.work
          break
        case 'profile' :
          ob.report = this.option.param.user
          break
        case 'book' :
          ob.report = this.option.param.book
          break
        case 'post' :
          ob.report = this.option.param.post
          ob.book = this.option.param.book
          ob.bookorg = this.title
          break
        case 'comment' :
          ob.report = this.option.param.comment
          ob.book = this.option.param.post
          ob.bookorg = this.title + ' / ' + this.subtitle
          break
      }
      this.$http.post('/api/cs/create', ob).then((row) => {
        console.log(row)
        if (row.success) {
          this.$emit('submit')
        } else {
        }
      })
    }
  },
  components: {
    AbsPopup,
    UInput,
    TabBar
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 20px;
  width: 500px;
  text-align: left;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  color: var(--text-base);
}
.popup-body > li {
  display: flex;
  color: var(--text-title);
}
.popup-body > li > span:first-child {
  width: 100px;
  text-align: right;
  padding-right: 15px;
}
.popup-body .line {
  width: 100%;
  border-bottom: 1px solid var(--line-title);
  margin: 5px 0px;
}
.popup-body > div {
  display: flex;
  margin: 10px;
}
.popup-body .input {
  display: flex;
  flex-direction: row;
  flex: 1;
  border: 1px solid var(--line-guide);
  padding-left: 5px;
}
.popup-body .selectType {
  display: flex;
  flex-direction: row;
  list-style: none;
}
.selectType > div:first-child > span {
  padding-right: 15px;
}
.popup-body div:last-child {
  display: flex;
  flex-direction: column;
}
.discription {
  border: 1px solid var(--line-guide);
  padding: 5px;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ReportPopup.vue